import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Application.css';
import tasbihAppHeroImage from '../img/tasbih_app_hero.png';
import wallpaperIoHeroImage from '../img/wallpaper_io_hero.png'; // Assurez-vous que ce chemin est correct

const Application = () => {
    const navigate = useNavigate();
    const iosLinkTasbih = "https://yuzult0.web.app";      // Lien pour l'application iOS Tasbih
    const androidLinkTasbih = "https://yuzult0.web.app";  // Lien pour l'application Android Tasbih
    const iosLinkWallpaper = "https://wallpaperio.example.com/ios"; // Lien pour l'application iOS Wallpaper io
    const androidLinkWallpaper = "https://wallpaperio.example.com/android"; // Lien pour l'application Android Wallpaper io

    const goToLicenseTasbih = () => {
        navigate('/license');
    };

    const goToPrivacyPolicyTasbih = () => {
        navigate('/privacy-policy');
    };

    const goToLicenseWallpaper = () => {
        navigate('/license-wallio');
    };

    const goToPrivacyPolicyWallpaper = () => {
        navigate('/privacy-policy-wallpaperio');
    };

    const goToPrivacyPolicyAd = () => {
        navigate('/privacy-policy-ad');
    };

    return (
        <section className="app-hero">
            {/* Tasbih App Section */}
            <div className="app-hero-text">
                <h1>Tasbih App</h1>
                <p>Experience the serenity of Dhikr with our Digital Tasbih.</p>
            </div>
            <div className="hero-img">
                <img src={tasbihAppHeroImage} alt="Tasbih Dhikr" />
            </div>
            <div className="download-buttons">
                <a href={iosLinkTasbih} className="download-btn ios">
                    <i className="ri-apple-fill"></i> Download on iOS
                </a>
                <a href={androidLinkTasbih} className="download-btn android">
                    <i className="ri-android-fill"></i> Download on Android
                </a>
            </div>
            <div className="additional-links">
                <button onClick={goToLicenseTasbih} className="link-btn">
                    License
                </button>
                <button onClick={goToPrivacyPolicyTasbih} className="link-btn">
                    Privacy Policy
                </button>
            </div>

            {/* Wallpaper io Section */}
            <div className="app-hero-text">
                <h1>Wallpaper io</h1>
                <p>Beautify your phone with stunning wallpapers from Wallpaper io.</p>
            </div>
            <div className="hero-img">
                <img src={wallpaperIoHeroImage} alt="Wallpaper io" />
            </div>
            <div className="download-buttons">
                <a href={iosLinkWallpaper} className="download-btn ios">
                    <i className="ri-apple-fill"></i> Download on iOS
                </a>
                <a href={androidLinkWallpaper} className="download-btn android">
                    <i className="ri-android-fill"></i> Download on Android
                </a>
            </div>
            <div className="additional-links">
                <button onClick={goToLicenseWallpaper} className="link-btn">
                    License
                </button>
                <button onClick={goToPrivacyPolicyWallpaper} className="link-btn">
                    Privacy Policy
                </button>
                <button onClick={goToPrivacyPolicyAd} className="link-btn">
                    Privacy Policy AdMob
                </button>
            </div>
        </section>
    );
}

export default Application;
